export default __webpack_public_path__ + "static/media/vessel_icon_selected.b621c456.svg";